export default __webpack_public_path__ + "static/media/ideation2.241baee2.png";